import React, { memo, useCallback } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import classNames from 'classnames';

import { useJobFilterContext } from '../../../contexts/JobFilterProvider';

import JobSection from './JobSection';

import styles from './OpeningsListElement.module.scss';

const OpeningsListElement = memo(({ opening, addBorder = false, isPublic = false }) => {
  const { uuid } = opening;

  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();
  const page = searchParams.get('page');
  const { updateJobFilterValues } = useJobFilterContext();

  const onClickOpening = useCallback(
    (id) => {
      if (window.innerWidth < 768) {
        navigate(`/jobs/details/${id}`);
      } else {
        updateJobFilterValues('id', id);
        navigate(`${pathname}?id=${id}`);
      }
    },
    [window.innerWidth, pathname, page]
  );

  return (
    <div
      className={classNames(styles.openingItemParent, addBorder && styles.selectedItem)}
      onClick={() => onClickOpening(uuid)}
      role="presentation"
    >
      <JobSection job={opening} isPublic={isPublic} />
    </div>
  );
});

export default OpeningsListElement;
